import createElement from '../../shared/helpers/createElement';

export default class InputPasswordManager {
  constructor() {
    document
      .querySelectorAll('.c-form__security')
      .forEach(InputPasswordManager.startInputPassword);
  }

  static startInputPassword(securityElement: HTMLElement) {
    if (
      securityElement.classList.contains(
        'c-form__security__togglePassword--initiated'
      )
    )
      return;
    securityElement.classList.add(
      'c-form__security__togglePassword--initiated'
    );

    const inputPassword = securityElement.querySelector<HTMLInputElement>(
      'input[type="password"]'
    );
    if (!inputPassword) return;

    const iconPassword = createElement('i', {
      class: 'icon icon-eyeClose',
      role: 'img',
    });

    const togglePasswordButton = createElement(
      'button',
      {
        class: 'c-form__security__togglePassword',
        type: 'button',
      },
      iconPassword
    );

    togglePasswordButton.addEventListener('click', () => {
      const inputType = inputPassword.getAttribute('type');
      inputPassword.setAttribute(
        'type',
        inputType === 'password' ? 'text' : 'password'
      );
      iconPassword.classList.toggle('icon-eyeClose');
      iconPassword.classList.toggle('icon-eye');
      inputPassword.focus();
    });

    securityElement.append(togglePasswordButton);
  }
}
